import type { MultiformatLayout } from "./store/types";

export function containsImageStyle(layout: MultiformatLayout, imageStyles?: string[]): boolean {
  return Boolean(
    !imageStyles || // Include if no filter
    layout.images.length === 0 || // Include if no images
    (layout.images[0] && imageStyles.includes(layout.images[0]?.type ?? "")),
  );
}
